import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { createHarvest } from '../../services/Harvest/harvestService';
import ErrorModal from '../Modals/ErrorModal';
import SuccessModal from '../Modals/SuccessModal';
import InputField from '../Utils/InputField';
import DateInput from '../Utils/DateInput';
import { convertDateToISO } from '../Utils/utils';

const CreateHarvestModal = ({ show, handleClose, refreshHarvests, onCreated }) => {
  const { register, handleSubmit, formState: { errors }, reset, control, setValue } = useForm();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const onSubmit = async (data) => {
    try {
      const harvestData = {
        ...data,
        startDate: data.startDate ? convertDateToISO(data.startDate) : null,
        endDate: data.endDate ? convertDateToISO(data.endDate) : null,
        active: true,
      };
      const created = await createHarvest(harvestData);

      if (onCreated) {
        onCreated({
          id: created.uuid,
          description: created.name,
        });
      } else {
        setSuccessMessage('Safra criada com sucesso!');
        setShowSuccessModal(true);
        setValue('startDate', null);
        setValue('endDate', null);
      }

      reset();
    } catch (error) {
      setErrorMessage(error.message || 'Erro ao criar safra.');
      setShowErrorModal(true);
    }
  };

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    refreshHarvests();
    handleClose();
  };

  useEffect(() => {
    if (!show) {
      reset();
    }
  }, [show, reset]);

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Safra</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.stopPropagation();
              handleSubmit(onSubmit)(e);
            }}
          >
            <Row>
              <Col md={12}>
                <InputField
                  label="Descrição"
                  name="description"
                  placeholder="Digite a descrição"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Descrição é obrigatória' }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Controller
                  name="startDate"
                  control={control}
                  render={({ field, fieldState }) => (
                    <DateInput
                      isEditing = { false }
                      label="Data de Início"
                      value={field.value}
                      onChange={field.onChange}
                      error={fieldState.error}
                      placeholder="__/__/____"
                    />
                  )}
                  rules={{
                    required: 'Data de início é obrigatória',
                  }}
                />
              </Col>
              <Col md={6}>
                <Controller
                  name="endDate"
                  control={control}
                  render={({ field, fieldState }) => (
                    <DateInput
                      isEditing = { false }
                      label="Data de Fim"
                      value={field.value}
                      onChange={field.onChange}
                      error={fieldState.error}
                      placeholder="__/__/____"
                    />
                  )}
                  rules={{
                    required: 'Data de fim é obrigatória',
                  }}
                />
              </Col>
            </Row>
            <Button variant="primary" className="button-custom w-100 mt-3" type="submit">
              Cadastrar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ErrorModal
        show={showErrorModal}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
      />

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        successMessage={successMessage}
      />
    </>
  );
};

export default CreateHarvestModal;